import { DateTime } from 'luxon'

export function getTimezoneLabel(dt: string, timezone: string): string {
  return getTimezoneLabelTokens(dt, timezone)[0]
}

export function getTimezoneLabelTokens(dt: string, timezone: string): [string, string, string, string] {
  const lDt = DateTime.fromISO(dt, { zone: timezone })
  const hasAbbr = !lDt.zoneName?.startsWith('GMT')
  const name = timezone.replace('_', ' ')
  const shortOffset = lDt.toFormat('ZZ')
  const longOffset = lDt.toFormat('ZZZZ')
  const fullName = `${name} (${hasAbbr ? `${longOffset} ${shortOffset}` : shortOffset})`
  return [fullName, name, shortOffset, longOffset]
}